import logo from './logo.svg';
import './App.css';
import Home from './Home/Home';
import Footer from './Components/Footer';
import Header from './Components/Header';
import FloatingSocialButtons from './Components/FloatingSocialButton';


function App() {
  return (
    <div className=''>

    <FloatingSocialButtons/>
    <Home/>

    </div>
  );
}

export default App;
